import React from 'react';
import styled from 'styled-components';

import fotoGrupo2 from '../assets/img/foto_grupo_2.webp';
import DinosaurEasterEgg from './DinosaurEasterEgg';
import { useDinosaurContext } from '../contexts/DinosaurContext';

const SobreSectionContainer = styled.section`
  display: flex;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 900px) {
    flex-direction: column;
    min-height: unset;
  }
`;

const SobreLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  background: #222;
  overflow: hidden;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 40vh;
    order: 2;
  }
`;

const SobreImg = styled.img`
  width: 100%;
  height: 100vh;
  object-fit: cover;
  filter: grayscale(1);

  @media (max-width: 900px) {
    height: 40vh;
  }
`;

const SobreRight = styled.div`
  flex: 1.1;
  background: #ba3b3b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0eadd;
  padding: 0 4vw;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 50vh;
    order: 1;
  }
`;

const SobreContent = styled.div`
  max-width: 600px;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 95vw;
    padding: 24px 0;
  }
`;

const SobreTitle = styled.div`
  position: relative;
  margin-bottom: 32px;
  min-height: 80px;

  @media (max-width: 900px) {
    min-height: 40px;
  }
`;

const SobreMain = styled.span`
  font-family: 'League Spartan', Arial, Helvetica, sans-serif;
  font-size: 80px;
  font-weight: bold;
  color: #f0eadd;
  line-height: 1;
  display: inline-block;

  @media (max-width: 1100px) {
    font-size: 48px;
  }
`;

const SobreNos = styled.span`
  position: absolute;
  left: 170px;
  top: 38px;
  font-family: 'Times New Roman', Times, serif;
  font-size: 48px;
  font-style: italic;
  color: #111;
  font-weight: 400;
  z-index: 2;
  letter-spacing: 0.01em;
  cursor: pointer;

  @media (max-width: 1100px) {
    font-size: 28px;
    left: 100px;
    top: 22px;
  }
`;

const SobreText = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 23.5px;
  color: #f0eadd;
  line-height: 1.4;
  text-align: left;

  @media (max-width: 1100px) {
    font-size: 16px;
  }
`;

const SobreSection = () => {
  const { triggerEasterEgg } = useDinosaurContext();

  return (
    <>
      <SobreSectionContainer id="sobre">
        <SobreLeft>
          <SobreImg src={fotoGrupo2} alt="Foto do grupo Quatro Takes" />
        </SobreLeft>
        <SobreRight>
          <SobreContent>
            <SobreTitle>
              <SobreMain>Sobre</SobreMain>
              <SobreNos onClick={triggerEasterEgg}>nós</SobreNos>
            </SobreTitle>
            <SobreText>
              Quatro Takes é um coletivo formado por quatro profissionais apaixonados por cultura pop, com experiência em eventos, pré-estreias, tapetes vermelhos e cabines de imprensa. Antes de se unirem, cada membro produzia conteúdo individualmente, mas perceberam que juntos poderiam oferecer análises mais profundas e engajadas.<br />
              Nosso grupo é diverso e autêntico: além de uma perspectiva masculina, contamos com olhares femininos, incluindo duas pessoas com deficiência (PCDs) e uma pessoa LGBTQIAPN+. Essa pluralidade enriquece nossas análises, tornando-as mais completas e inclusivas.<br />
              Nossa missão é comentar, analisar e celebrar a cultura pop com profissionalismo, sensibilidade e, claro, sempre com uma pitada de humor. Trabalhamos com as principais assessorias do mercado, garantindo conteúdo de qualidade e cobertura fiel das narrativas que importam.<br />
              Buscamos ocupar espaços com vozes que nem sempre são ouvidas. Aqui, cada take importa, porque um só ponto de vista seria muito pouco.
            </SobreText>
          </SobreContent>
        </SobreRight>
      </SobreSectionContainer>
      
      <DinosaurEasterEgg />
    </>
  );
};

export default SobreSection;
